import React from 'react';
import parse from 'html-react-parser';

const EvidenceCard = props => {
  const { evidence } = props;

  const parseJSON = (description, className = '') => {
    // If our description contains <br /> (line breaks), break them out.
    const regex = RegExp(/<br *\/>/gim);
    const descriptionSplit = description.split(regex);

    if (descriptionSplit.length > 1) {
      return (
        // The <p /> tags add spacing for the description sections, please keep them.
        <React.Fragment>
          <p></p>
          {descriptionSplit.map((desc, index) => (
            <div className={className} key={index}>
              {desc ? parse(desc) : <br />}
            </div>
          ))}
          <p></p>
        </React.Fragment>
      );
    }

    // If there are no breaks return one <p /> tag.
    return (
      <p className={className}>{descriptionSplit.map(desc => parse(desc))}</p>
    );
  };

  let notes = null;
  if (evidence.notes) {
    notes = parseJSON(evidence.notes, 'notes');
  }

  return (
    <div className="EvidenceCard">
      {evidence.evidence_description && parseJSON(evidence.evidence_description, 'EvidenceCard__evidence-description')}
      <p className="description">{evidence.description}</p>
      {notes}
      {evidence.scope && (
        <dl className="meta">
          <dt>Scope:</dt>
          <dd>{evidence.scope}</dd>
        </dl>
      )}
    </div>
  );
};

export default EvidenceCard;
